import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { timezoneByCode } from '@shared/constants/timezone-constants';
import { default as dayjs, default as utc } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: 'app-autopay-effective-date',
  templateUrl: './autopay-effective-date.component.html',
  styleUrls: ['./autopay-effective-date.component.scss'],
})
export class AutopayEffectiveDateComponent implements OnInit {
  @Output() selectEffectiveDateEmitter = new EventEmitter<Date>();

  readonly MAX_START_DATE_DAYS = 30;
  readonly DATE_STRING_FORMAT = 'YYYY-MM-DD';

  minStartDate: dayjs.Dayjs;
  maxStartDate: dayjs.Dayjs;
  selectedStartDate: dayjs.Dayjs;

  get maxStartDateString(): string {
    return this.maxStartDate.format(this.DATE_STRING_FORMAT);
  }
  get minStartDateString(): string {
    return this.minStartDate.format(this.DATE_STRING_FORMAT);
  }
  get selectedStartDateString(): string {
    return this.selectedStartDate.format(this.DATE_STRING_FORMAT);
  }

  constructor() {}

  ngOnInit() {
    this.calculateDates();
  }

  calculateDates() {
    const now = dayjs(new Date().toISOString()).tz(
      timezoneByCode.get('MT').location,
    );
    this.selectedStartDate = this.nextBusinessDay(now);
    this.minStartDate = this.selectedStartDate.clone();

    let max = now.add(this.MAX_START_DATE_DAYS + 1, 'day');
    this.maxStartDate = this.nextBusinessDay(max, -1);

    this.selectEffectiveDateEmitter.emit(this.selectedStartDate.toDate());
  }

  nextBusinessDay(date: dayjs.Dayjs, addSubtract: 1 | -1 = 1): dayjs.Dayjs {
    let nextDay: dayjs.Dayjs;
    if (date.hour() >= 14 && addSubtract === 1) {
      nextDay = date.add(addSubtract * 2, 'day');
    } else {
      nextDay = date.add(addSubtract, 'day');
    }
    while (nextDay.day() === 0 || nextDay.day() === 6) {
      nextDay = nextDay.add(addSubtract, 'day');
    }
    return nextDay;
  }

  isWeekday(dateString: string) {
    const date = new Date(dateString);
    const utcDay = date.getUTCDay();
    // return false for Sunday/Saturday
    return utcDay !== 0 && utcDay !== 6;
  }

  valueChanged($event: CustomEvent) {
    const date = dayjs($event.detail.value).tz(
      timezoneByCode.get('MT').location,
      true,
    );
    this.selectEffectiveDateEmitter.emit(date.toDate());
  }
}
